import { Dispatch, SetStateAction, useEffect } from 'react';
import { DialogStyled, UserAvatar } from 'src/components';
import type { OrgMember } from 'src/types';
import { RoleDropdown } from '.';

type Props = {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  handleConfirmDelete: () => void;
  selectedUser: OrgMember | null;
  isRemovingUser: boolean;
};

export const KickUserModal = ({
  show,
  setShow,
  handleConfirmDelete,
  selectedUser,
  isRemovingUser,
}: Props) => {
  useEffect(() => {
    if (show && !selectedUser) {
      setShow(false);
    }
  }, [show, selectedUser, setShow]);

  return (
    <DialogStyled
      open={show}
      onClose={() => setShow(false)}
      customWidth={'fit'}
      customMaxWidth={400}
    >
      <div className='flex w-full flex-col items-center justify-center gap-6 p-6'>
        <div className='flex w-full flex-row flex-wrap items-center justify-between gap-4 sm:flex-nowrap sm:justify-center'>
          <div className='order-1 flex h-8 w-8 cursor-pointer items-center justify-center transition-all hover:opacity-90'>
            <UserAvatar name={selectedUser?.name} photo={selectedUser?.photo} />
          </div>

          <div className='order-3 flex w-full flex-col items-start justify-center gap-1 whitespace-pre sm:order-2'>
            <h4 className='heading-100'>
              {selectedUser?.name || selectedUser?.email}
            </h4>
            {/* only show this if the selected user has a name, otherwise only show the email */}
            <h5 className='text-100'>
              {selectedUser?.name ? selectedUser.email : ''}
            </h5>
          </div>

          <div className='order-2 sm:order-3'>
            <RoleDropdown
              showDropdown={false}
              handleShowDropdown={() => {}}
              isPending={false}
              role={selectedUser?.role || 'member'}
              displayPending={false}
              handleSelectRole={() => {}}
              disableDropdown={true}
              dropdownId={`kick-user-role-dropdown-${selectedUser?.id}`}
              userId={`kick-user-${selectedUser?.id}-role`}
              excludeDropdownSpace={true}
              showMemberBorder={true}
            />
          </div>
        </div>
        <div className='flex w-full flex-row flex-wrap items-center justify-center gap-2'>
          <button
            onClick={() => setShow(false)}
            disabled={isRemovingUser}
            className='button-secondary h-12 w-full sm:w-fit'
          >
            No! Keep User
          </button>
          <button
            onClick={(e) => handleConfirmDelete()}
            disabled={isRemovingUser}
            className={`button-primary h-12 w-full sm:w-fit ${isRemovingUser ? 'bg-gray-400 hover:bg-gray-400/70' : 'bg-rose-500 hover:bg-rose-500/70'}`}
          >
            Delete This User
          </button>
        </div>
      </div>
    </DialogStyled>
  );
};
